import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DXCAuthService } from './dxc-auth.service';

export const appLayoutGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const dxcAuthService = inject(DXCAuthService);
  const authToken = dxcAuthService.getAuthToken();
  const isLoggedIn = dxcAuthService.isLoggedIn();

  if (authToken && isLoggedIn) {
    return true;
  }

  // state.url is the destination URL from the router navigation — correct even during
  // initial hard-refresh navigation before router.routerState.snapshot.url is updated.
  dxcAuthService.clearSessionAndNavigateToAuth(router, state.url);
  return false;
};
